import {getPaddingsBlock, getPaddingsInline} from "@/pipes/theme.pipe";
import {css} from "styled-components";


export const getSectionPaddings = (padding) => css`
    padding-inline: ${getSectionPaddingsInline(padding)};
    padding-block: ${getSectionPaddingsBlock(padding)};
`

export const getSectionPaddingsInline = (padding) => css`
    clamp(${getPaddingsInline('containers', 'sm')}, 6vw, ${getPaddingsInline('containers', padding)})
`

export const getSectionPaddingsBlock = (padding) => css`
    clamp(${getPaddingsBlock('containers', 'sm')}, 4vw, ${getPaddingsBlock('containers', padding)})
`
